import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bookinnovacrystaforoutsttaion() {



const cardData = {
keyword: "Book Innova Crysta for Outstation From Pune",
headingDescription: "Citysky Cabs provides comfortable Innova Crysta outstation cab and taxi services from Pune for families, groups, corporate travellers, tourists, and passengers planning long-distance road journeys. The spacious 7-seater Innova Crysta is suitable for one-way trips, round trips, weekend holidays, family tours, corporate travel, intercity journeys, and multi-city travel plans. Passengers can choose private transportation for popular routes from Pune toward Mumbai, Goa, Mahabaleshwar, Lonavala, Nashik, Shirdi, Kolhapur, and other destinations. With air conditioning, comfortable seating, and useful luggage capacity, an Innova Crysta is a practical option for passengers looking for convenient private transportation for extended outstation travel.",


topPlaces: [
    {
        title: "Mumbai",
        description: "Mumbai is a major destination for Pune passengers travelling for business, family visits, shopping, airport connections, and personal work. An Innova Crysta outstation cab from Pune provides comfortable private transportation for individuals, families, and groups. The spacious cabin and luggage area make it suitable for direct one-way journeys as well as planned return trips."
    },
    {
        title: "Goa",
        description: "Goa is a popular long-distance destination for families, friends, tourists, and groups planning holidays from Pune. An Innova Crysta provides comfortable seating and practical luggage capacity for the extended road journey. It is suitable for weekend vacations, family tours, group travel, and multi-day Goa itineraries where passengers prefer travelling together in a private vehicle."
    },
    {
        title: "Mahabaleshwar",
        description: "Mahabaleshwar is a popular hill station frequently visited from Pune for weekend breaks, family holidays, and sightseeing. An Innova Crysta outstation taxi provides a spacious travel option for families and groups. Passengers can use the vehicle for one-day trips, weekend stays, and sightseeing plans while carrying their luggage comfortably."
    },
    {
        title: "Nashik",
        description: "Nashik attracts passengers from Pune for religious visits, tourism, business requirements, and family travel. An Innova Crysta is suitable for private intercity transportation between Pune and Nashik, especially when several passengers are travelling together. Comfortable seating and useful luggage space make it practical for both one-way and round-trip journeys."
    },
    {
        title: "Shirdi",
        description: "Shirdi is an important pilgrimage destination for families, devotees, senior passengers, and groups travelling from Pune. An Innova Crysta outstation cab provides direct private transportation for pilgrimage trips with useful space for passengers and luggage. The vehicle is suitable for planned one-way journeys, return trips, and family tours."
    },
    {
        title: "Kolhapur",
        description: "Kolhapur is a significant Maharashtra destination for tourism, business travel, family visits, and religious journeys. An Innova Crysta from Pune provides a comfortable private option for passengers travelling together over the longer road route. The spacious vehicle can accommodate luggage and is suitable for both short stays and extended travel plans."
    },
    {
        title: "Lonavala",
        description: "Lonavala is a convenient weekend destination from Pune and is popular for family outings, group trips, resort stays, and sightseeing. An Innova Crysta outstation taxi is useful for passengers travelling together with luggage. The vehicle provides comfortable private transportation for one-day excursions and weekend plans."
    },
    {
        title: "Aurangabad",
        description: "Aurangabad is a popular destination for history, tourism, family travel, and business visits. An Innova Crysta can provide spacious private transportation from Pune for passengers planning a longer intercity journey. Families and groups can use the vehicle for sightseeing, personal visits, and multi-day travel schedules."
    },
    {
        title: "Alibaug",
        description: "Alibaug is a popular leisure destination for families, friends, and groups looking for a short break from Pune. An Innova Crysta is suitable for weekend trips, resort visits, family outings, and group travel. The spacious cabin provides useful comfort for passengers carrying luggage and other belongings during the journey."
    },
    {
        title: "Satara",
        description: "Satara is a useful destination for passengers travelling from Pune for business, family visits, tourism, and onward travel toward southern Maharashtra. An Innova Crysta provides a practical private transportation option for groups and families. Comfortable seating and luggage capacity make it suitable for both direct travel and planned return journeys."
    }
],

services: [
    {
        name: "Innova Crysta Outstation Cab Pune",
        description: "Innova Crysta Outstation Cab Pune provides comfortable private transportation for passengers travelling from Pune to destinations across Maharashtra and other cities. Families, friends, corporate teams, and tourists can use the vehicle for holidays, pilgrimage trips, business travel, sightseeing, and long-distance journeys. The spacious 7-seater cabin offers useful room for passengers and luggage."
    },
    {
        name: "Innova Crysta Outstation Taxi Pune",
        description: "Innova Crysta Outstation Taxi Pune is suitable for customers planning private intercity travel from Pune. The vehicle can be arranged for one-way journeys, round trips, weekend travel, family tours, corporate requirements, and sightseeing. Its spacious seating and practical luggage capacity make it useful for passengers travelling together over longer distances."
    },
    {
        name: "Innova Crysta Outstation Booking Pune",
        description: "Innova Crysta Outstation Booking Pune allows passengers to plan spacious private transportation for their upcoming outstation journey. Advance arrangements can be useful for family vacations, weekend trips, corporate travel, weddings, pilgrimages, and tourist tours. The 7-seater vehicle is suitable when several passengers need to travel together with luggage."
    },
    {
        name: "Innova Crysta Outstation Rental Pune",
        description: "Innova Crysta Outstation Rental Pune provides a practical vehicle option for families, groups, professionals, and tourists planning journeys outside Pune. Rental requirements can include long-distance travel, sightseeing tours, weekend holidays, family functions, corporate trips, and intercity transportation. The comfortable cabin makes extended road travel more convenient."
    },
    {
        name: "Innova Crysta on Rent for Outstation Pune",
        description: "Innova Crysta on Rent for Outstation Pune is suitable for passengers who need a spacious private vehicle for travel beyond the city. It can be used for family holidays, group tours, business journeys, weekend trips, pilgrimages, and sightseeing routes. The vehicle provides comfortable seating and useful luggage space for passengers travelling together."
    },
    {
        name: "Innova Crysta Hire for Outstation Pune",
        description: "Innova Crysta Hire for Outstation Pune provides a convenient transportation option for passengers planning longer road journeys. Families, friends, corporate teams, and tourists can hire the vehicle for one-way travel, return trips, weekend holidays, and extended tours. The 7-seater layout is useful when a group wants to travel together in one private cab."
    },
    {
        name: "Innova Crysta Cab for Outstation Trip Pune",
        description: "Innova Crysta Cab for Outstation Trip Pune is suitable for planned road trips from Pune to destinations such as Mumbai, Goa, Mahabaleshwar, Nashik, Shirdi, Kolhapur, and other cities. The spacious vehicle supports family travel, group holidays, sightseeing, pilgrimages, and corporate journeys. Comfortable seating and luggage capacity make it practical for longer routes."
    },
    {
        name: "Innova Crysta Taxi for Outstation Travel Pune",
        description: "Innova Crysta Taxi for Outstation Travel Pune provides private transportation for passengers travelling outside Pune for personal, professional, or tourism purposes. It can support family tours, business visits, weekend travel, sightseeing, and intercity journeys. The spacious cabin is suitable for groups carrying luggage and travelling over extended distances."
    },
    {
        name: "Innova Crysta for Long Distance Travel Pune",
        description: "Innova Crysta for Long Distance Travel Pune is a suitable option for passengers planning extended road journeys where comfortable seating and luggage space are important. Families, groups, and corporate travellers can use the vehicle for multi-hour routes, holidays, business travel, pilgrimages, and tourist tours from Pune to various destinations."
    },
    {
        name: "Innova Crysta for Family Outstation Trip Pune",
        description: "Innova Crysta for Family Outstation Trip Pune provides spacious private transportation for families travelling outside the city. It can be used for holidays, pilgrimages, sightseeing, family visits, weekend breaks, and multi-day tours. The 7-seater cabin offers comfortable seating while the luggage area provides practical space for travel bags and belongings."
    },
    {
        name: "Innova Crysta for Group Outstation Travel Pune",
        description: "Innova Crysta for Group Outstation Travel Pune is suitable for friends, relatives, tourist groups, and small teams planning to travel together. The spacious 7-seater vehicle helps keep the group in one private cab while providing useful luggage capacity. It can be arranged for holidays, sightseeing, weekend trips, events, and long-distance journeys."
    },
    {
        name: "Innova Crysta for Corporate Outstation Travel Pune",
        description: "Innova Crysta for Corporate Outstation Travel Pune provides comfortable transportation for executives, employees, clients, and visiting business teams. It can be used for intercity meetings, conferences, office visits, corporate events, airport connections, and business tours. The spacious cabin makes group corporate travel more convenient during longer road journeys."
    },
    {
        name: "Innova Crysta for Weekend Trip Pune",
        description: "Innova Crysta for Weekend Trip Pune is suitable for families and groups planning short breaks from the city. Popular destinations such as Lonavala, Mahabaleshwar, Alibaug, and other leisure locations can be covered in a private vehicle. Comfortable seating and luggage capacity make the Innova Crysta practical for weekend travel."
    },
    {
        name: "Innova Crysta One Way Outstation Cab Pune",
        description: "Innova Crysta One Way Outstation Cab Pune is suitable for passengers requiring private transportation in a single direction from Pune to another city or destination. It can be useful for relocation, family visits, airport travel, business requirements, and holiday departures. The spacious 7-seater vehicle provides comfortable seating for passengers with luggage."
    },
    {
        name: "Innova Crysta Round Trip Outstation Cab Pune",
        description: "Innova Crysta Round Trip Outstation Cab Pune provides a convenient private vehicle for passengers travelling from Pune to a destination and returning after completing their visit. It is suitable for one-day sightseeing, weekend holidays, pilgrimages, family tours, and business trips. The spacious cabin is practical for groups carrying luggage throughout the journey."
    },
    {
        name: "Affordable Innova Crysta Outstation Cab Pune",
        description: "Affordable Innova Crysta Outstation Cab Pune is suitable for passengers seeking spacious private group transportation while planning their travel expenses carefully. Families and groups can share one vehicle for longer journeys, making the 7-seater layout practical for travel. It can support holidays, sightseeing, family tours, pilgrimages, and business trips."
    },
    {
        name: "AC Innova Crysta Outstation Cab Pune",
        description: "AC Innova Crysta Outstation Cab Pune provides an air-conditioned private transportation option for passengers travelling on longer routes from Pune. The vehicle is suitable for families, tourists, corporate groups, and friends planning extended road journeys. Comfortable seating and luggage space add practicality for multi-hour and multi-day travel."
    },
    {
        name: "Luxury Innova Crysta Outstation Cab Pune",
        description: "Luxury Innova Crysta Outstation Cab Pune offers a spacious and comfortable private travel option for passengers who prefer a premium-feeling road journey. It can be used for corporate travel, family vacations, weddings, tourist tours, airport connections, and long-distance trips. The roomy cabin provides useful comfort for passengers travelling together with luggage."
    },
    {
        name: "7 Seater Innova Crysta Outstation Pune",
        description: "7 Seater Innova Crysta Outstation Pune is suitable for families, friends, corporate groups, and tourists who require additional seating for an intercity journey. The vehicle can accommodate passengers and travel bags conveniently and is suitable for holidays, weekend trips, pilgrimages, sightseeing, family tours, and longer road travel from Pune."
    },
    {
        name: "Innova Crysta Outstation Taxi Near Me Pune",
        description: "Innova Crysta Outstation Taxi Near Me Pune is useful for passengers searching for a convenient 7-seater cab for travel outside Pune. The vehicle can support family journeys, group tours, business trips, airport travel, weekend holidays, and long-distance routes. Spacious seating and luggage capacity make it practical for passengers looking for private transportation."
    },
    {
        name: "Innova Crysta for Intercity Travel Pune",
        description: "Innova Crysta for Intercity Travel Pune provides a comfortable private transportation option between Pune and other cities. It can be used for business visits, family travel, tourism, pilgrimages, airport connections, and personal journeys. The spacious 7-seater vehicle is suitable for passengers who prefer travelling together with sufficient luggage space."
    },
    {
        name: "Innova Crysta Tourist Cab for Outstation Pune",
        description: "Innova Crysta Tourist Cab for Outstation Pune is suitable for tourists and families planning sightseeing tours outside the city. The vehicle can support weekend holidays, multi-day tours, pilgrimage routes, hill-station visits, and multi-location itineraries. Its spacious seating and luggage capacity make it convenient for longer tourist journeys."
    },
    {
        name: "Innova Crysta Outstation Car Rental Pune",
        description: "Innova Crysta Outstation Car Rental Pune provides a spacious private vehicle for passengers planning travel beyond Pune. Rental requirements can include family vacations, corporate tours, sightseeing, weekend trips, weddings, pilgrimages, and intercity travel. The 7-seater vehicle is useful for groups that want comfortable transportation throughout their planned route."
    },
    {
        name: "Innova Crysta Cab for Family Tour Pune",
        description: "Innova Crysta Cab for Family Tour Pune is suitable for families planning holidays, sightseeing tours, pilgrimages, and multi-day journeys from Pune. The spacious cabin allows family members to travel together while the luggage area accommodates travel bags and belongings. It can be used for both nearby destinations and longer intercity tours."
    },
    {
        name: "Innova Crysta for Multi City Trip Pune",
        description: "Innova Crysta for Multi City Trip Pune is a practical option for passengers planning an itinerary covering several destinations from Pune. Families, tourists, and groups can use the vehicle for multi-day holidays, sightseeing tours, business travel, pilgrimages, and combined destination trips. The spacious cabin and luggage capacity are useful when travelling between multiple cities."
    }
],

tableData: [
    ["Innova Crysta Outstation Cab Pune"],
    ["Innova Crysta Outstation Taxi Pune"],
    ["Innova Crysta Outstation Booking Pune"],
    ["Innova Crysta Outstation Rental Pune"],
    ["Innova Crysta on Rent for Outstation Pune"],
    ["Innova Crysta Hire for Outstation Pune"],
    ["Innova Crysta Cab for Outstation Trip Pune"],
    ["Innova Crysta Taxi for Outstation Travel Pune"],
    ["Innova Crysta for Long Distance Travel Pune"],
    ["Innova Crysta for Family Outstation Trip Pune"],
    ["Innova Crysta for Group Outstation Travel Pune"],
    ["Innova Crysta for Corporate Outstation Travel Pune"],
    ["Innova Crysta for Weekend Trip Pune"],
    ["Innova Crysta One Way Outstation Cab Pune"],
    ["Innova Crysta Round Trip Outstation Cab Pune"],
    ["Affordable Innova Crysta Outstation Cab Pune"],
    ["AC Innova Crysta Outstation Cab Pune"],
    ["Luxury Innova Crysta Outstation Cab Pune"],
    ["7 Seater Innova Crysta Outstation Pune"],
    ["Innova Crysta Outstation Taxi Near Me Pune"],
    ["Innova Crysta for Intercity Travel Pune"],
    ["Innova Crysta Tourist Cab for Outstation Pune"],
    ["Innova Crysta Outstation Car Rental Pune"],
    ["Innova Crysta Cab for Family Tour Pune"],
    ["Innova Crysta for Multi City Trip Pune"]
],

whychoose: [
    {
        WhyChooseheading: "Comfortable 7-Seater Travel",
        WhyChoosedescription: "The Innova Crysta provides spacious seating for families, friends, corporate teams, and tourist groups travelling together from Pune. The 7-seater layout and practical luggage area make it suitable for long-distance journeys where passengers need additional room for comfort and personal belongings."
    },
    {
        WhyChooseheading: "Suitable for Long Routes",
        WhyChoosedescription: "Outstation journeys from Pune can involve several hours of road travel, making comfortable transportation important for passengers. An Innova Crysta is suitable for routes toward Mumbai, Goa, Mahabaleshwar, Nashik, Shirdi, Kolhapur, and other destinations where families and groups prefer private transportation."
    },
    {
        WhyChooseheading: "One Way and Return Options",
        WhyChoosedescription: "Different travel plans can be supported with one-way and round-trip transportation depending on the passenger's itinerary. One-way travel can suit relocation or onward journeys, while round trips are useful for sightseeing, family vacations, pilgrimages, weekend holidays, and planned business visits."
    },
    {
        WhyChooseheading: "Family-Friendly Outstation Cab",
        WhyChoosedescription: "Families can use the Innova Crysta for holidays, religious visits, weekend breaks, family tours, and multi-day road trips. Travelling together in one spacious private vehicle can simplify group transportation while providing useful room for luggage, children's belongings, and other travel essentials."
    },
    {
        WhyChooseheading: "Convenient Corporate Transportation",
        WhyChoosedescription: "Corporate travellers can use Innova Crysta transportation for business meetings, conferences, client visits, office travel, hotel transfers, and intercity assignments. The larger cabin is practical for executives and visiting teams who need to travel together between Pune and other business destinations."
    },
    {
        WhyChooseheading: "Air-Conditioned Journey",
        WhyChoosedescription: "An air-conditioned Innova Crysta provides a comfortable private environment for passengers travelling on extended routes. Families, tourists, and business travellers can benefit from spacious seating during multi-hour journeys, particularly when carrying luggage and travelling between different cities."
    },
    {
        WhyChooseheading: "Useful for Tourist Tours",
        WhyChoosedescription: "Tourists can use an Innova Crysta for weekend holidays, sightseeing tours, hill-station visits, pilgrimage trips, and multi-city itineraries. Private transportation allows groups to travel together and plan their journey around selected destinations without relying on shared vehicles or fixed public transportation schedules."
    },
    {
        WhyChooseheading: "Flexible Multi-City Travel",
        WhyChoosedescription: "Passengers planning several stops can use an Innova Crysta for multi-city travel from Pune. The spacious vehicle provides useful luggage capacity for longer itineraries and is suitable for families, tourist groups, corporate teams, and friends travelling through multiple destinations during one planned trip."
    }
]


};








const faqData = [
{
question: "How can I book an Innova Crysta for an outstation trip from Pune?",
answer: "An outstation Innova Crysta can be booked by sharing your Pune pickup location, destination, travel date, passenger count, and preferred departure time. Citysky Cabs can organize the journey according to your route, whether you need a one-way transfer, round trip, or vehicle arrangement for a multi-day tour."
},
{
question: "Which destinations can I visit from Pune by Innova Crysta?",
answer: "An Innova Crysta can be arranged for outstation routes from Pune to destinations across Maharashtra and other states. Depending on the travel plan, passengers may choose routes toward Goa, Mumbai, Nashik, Shirdi, Kolhapur, Mahabaleshwar, Gujarat, Madhya Pradesh, Karnataka, Rajasthan, and other locations."
},
{
question: "Can I book an Innova Crysta for a one-way outstation journey?",
answer: "One-way outstation bookings can be arranged when you only need transportation from Pune to your destination. The booking request should include the pickup point, destination, travel date, passenger details, luggage requirements, and preferred departure time so the journey can be planned around your specific requirements."
},
{
question: "Can I book an Innova Crysta for an outstation round trip?",
answer: "Round-trip bookings are useful for travellers who plan to return to Pune after spending time at their destination. The itinerary can include the departure date, return date, stay duration, sightseeing plans, intermediate stops, and required pickup or drop locations so the complete journey can be coordinated in advance."
},
{
question: "Is Innova Crysta suitable for long-distance outstation travel?",
answer: "For longer road journeys, an Innova Crysta can be considered by families and small groups who prefer travelling together in one dedicated vehicle. The itinerary can include rest breaks, meal stops, sightseeing points, hotel transfers, and overnight stays when the journey extends across multiple days."
},
{
question: "Can I book an Innova Crysta for a multi-day outstation tour?",
answer: "Multi-day Innova Crysta bookings can be planned for holidays, family vacations, pilgrimage tours, destination events, and extended sightseeing programs. The transportation schedule can cover the complete route, including different cities, overnight destinations, local transfers, planned stops, and the final return journey to Pune."
},
{
question: "Can I travel with luggage in an outstation Innova Crysta?",
answer: "Passengers can share their approximate luggage requirements while requesting the vehicle. This is particularly useful for multi-day trips, family vacations, weddings, or journeys involving several bags. Citysky Cabs can consider the passenger group and luggage details while coordinating the outstation transportation."
},
{
question: "Can I book an Innova Crysta from Pune for a family pilgrimage?",
answer: "Families can arrange an Innova Crysta for pilgrimage routes involving one or several religious destinations. The itinerary can include temple visits, darshan schedules, overnight stays, meal breaks, rest points, and return travel, allowing the group to follow a coordinated route throughout the religious journey."
},
{
question: "What details should I provide when booking an outstation Innova Crysta?",
answer: "Provide the Pune pickup location, destination, travel date, number of passengers, luggage details, departure time, trip duration, and whether the journey is one-way or round trip. If you plan multiple stops or destinations, mention them during the booking request so the complete travel itinerary can be considered."
},
{
question: "Why choose Citysky Cabs to book Innova Crysta for outstation from Pune?",
answer: "Citysky Cabs handles outstation Innova Crysta requirements for family holidays, business travel, pilgrimages, weddings, sightseeing tours, weekend journeys, and multi-city trips. The booking can be coordinated around the route, passenger count, pickup point, luggage, travel dates, planned stops, and overall journey schedule."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Deepak Pawar",
feedback:
"I booked an Innova Crysta from Pune for a family outstation trip that covered several destinations over a few days. We had luggage with us and wanted to follow our own sightseeing schedule, so keeping the same cab throughout the trip was convenient. Citysky Cabs handled the travel arrangement according to our itinerary.",
rating: 5
},
{
id: 2,
name: "Miss. Neelam Joshi",
feedback:
"For a long-distance family journey from Pune, I chose an Innova Crysta through Citysky Cabs. We needed a one-way trip with luggage and an early morning departure. The booking details were discussed beforehand, which made it easier for us to organize the journey around our travel plans.",
rating: 5
}
];










    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Book Innova Crysta for Outstation From Pune",
  "image": "https://www.cityskycab.in/assets/images/book-innova-crysta-for-outstation-from-pune.webp",
  "description": "Book Innova Crysta for Outstation From Pune with Citysky Cabs for comfortable family holidays, business travel, weekend trips, long-distance journeys and private outstation transportation. Spacious seating, air conditioning, experienced drivers and convenient pickup options make the Innova Crysta suitable for couples, families and groups travelling from Pune to destinations across Maharashtra and nearby states. Customers can choose suitable one-way or round-trip travel plans and enquire about the applicable fare according to the destination, trip duration and travel requirements.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/book-innova-crysta-for-outstation-from-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Book Innova Crysta for Outstation From Pune | Innova Crysta Outstation Booking Pune | +91 8554819191
  </title>

  <meta
    name="description"
    content="Book Innova Crysta for Outstation From Pune with Citysky Cabs for family trips, business travel, weekend getaways and long-distance journeys. Check Innova Crysta outstation booking, taxi and cab options from Pune."
  />

  <meta
    name="keywords"
    content="Innova Crysta Outstation Cab Pune, Innova Crysta Outstation Taxi Pune, Innova Crysta Outstation Booking Pune, Innova Crysta Outstation Rental Pune, Book Innova Crysta for Outstation From Pune, Innova Crysta Outstation Pune, Innova Crysta Cab for Outstation Pune, Innova Crysta Taxi for Outstation Pune, Innova Crysta Hire for Outstation Pune, Innova Crysta Rental for Outstation Pune, Innova Crysta Outstation Car Pune, Innova Crysta Outstation Service Pune, Innova Crysta Outstation Booking From Pune, Innova Crysta Outstation Cab Booking Pune, Innova Crysta Outstation Taxi Booking Pune, Innova Crysta Outstation Hire Pune, Innova Crysta on Rent for Outstation Pune, Innova Crysta on Hire Pune Outstation, Innova Crysta Private Cab Pune Outstation, Innova Crysta Private Taxi Pune Outstation, AC Innova Crysta Outstation Pune, 7 Seater Innova Crysta Outstation Pune, Premium Innova Crysta Outstation Pune, Luxury Innova Crysta Outstation Pune, Comfortable Innova Crysta Outstation Pune, Pune Outstation Innova Crysta Cab, Pune Outstation Innova Crysta Taxi, Pune Outstation Innova Crysta Booking, Pune Outstation Innova Crysta Hire, Pune Outstation Innova Crysta Rental, Pune to Mahabaleshwar Innova Crysta, Pune to Lonavala Innova Crysta, Pune to Panchgani Innova Crysta, Pune to Nashik Innova Crysta, Pune to Shirdi Innova Crysta, Pune to Kolhapur Innova Crysta, Pune to Goa Innova Crysta, Pune to Aurangabad Innova Crysta, Pune to Mumbai Innova Crysta, Pune to Alibaug Innova Crysta, Pune to Satara Innova Crysta, Pune to Ratnagiri Innova Crysta, Pune to Ganpatipule Innova Crysta, Pune to Tarkarli Innova Crysta, Pune to Matheran Innova Crysta, One Way Innova Crysta Outstation Pune, One Way Outstation Cab Pune Innova Crysta, One Way Taxi Pune Innova Crysta, Round Trip Innova Crysta Outstation Pune, Round Trip Outstation Cab Pune Innova Crysta, Round Trip Taxi Pune Innova Crysta, Innova Crysta Outstation Cab with Driver Pune, Innova Crysta Outstation Taxi with Driver Pune, Innova Crysta Outstation Cab Per Km Pune, Innova Crysta Outstation Rate Pune, Innova Crysta Outstation Fare Pune, Innova Crysta Outstation Price Pune, Innova Crysta Per Km Rate Pune Outstation, Innova Crysta Cab Fare Pune Outstation, Innova Crysta Taxi Fare Pune Outstation, Pune Outstation Cab Price Innova Crysta, Pune Outstation Taxi Fare Innova Crysta, Family Outstation Cab Pune Innova Crysta, Group Travel Cab Pune Innova Crysta, Corporate Outstation Cab Pune Innova Crysta, Weekend Trip Innova Crysta Pune, Holiday Trip Innova Crysta Pune, Long Distance Cab Pune Innova Crysta, Intercity Innova Crysta Cab Pune, Maharashtra Outstation Innova Crysta Pune, Pune to Maharashtra Outstation Innova Crysta, Pune Outstation Cab Service, Pune Outstation Taxi Service, Pune Outstation Car Rental, Pune Outstation Cab Booking, Pune Outstation Taxi Booking, Citysky Cabs Innova Crysta Outstation Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bookinnovacrystaforoutsttaion;